import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";

class AdminPagarmeChargesModule extends HttpFactory {
  async getCharges(customerId: string): Promise<any[]> {
    return await this.get<any[]>(
      `${ENDPOINTS.ADMIN.PAYMENT.PAGARME_PROXY.CHARGES}`,
      { customer_id: customerId },
    );
  }

  async getCharge(chargeId: string): Promise<any[]> {
    return await this.get<any[]>(
      `${ENDPOINTS.ADMIN.PAYMENT.PAGARME_PROXY.CHARGES}${chargeId}`,
    );
  }
}

export { AdminPagarmeChargesModule };
